import { useState } from "react";
import { useAsyncDebounce } from "react-table";

//https://gist.github.com/srsandy/033aeb3d3f5b0cba3553fe65b6c0de09#file-globalfilter-js-L10

const ColumnFilter = ({ column }: any) => {
  const { filterValue, setFilter } = column;
  const [value, setValue] = useState(filterValue);
  const onChange = useAsyncDebounce((value) => {
    setFilter(value || undefined);
  }, 300);
  return (
    <span>
      <input
        className="border-0 h-6 w-full text-black"
        placeholder="Search"
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
      />
    </span>
  );
};

export default ColumnFilter;
